import memoize from 'lodash.memoize';
import gql from 'graphql-tag';
import createClient from '../../../clientSetup';
import { RETIREMENT_AGE } from '../utils';

export const RECOMMENDED_DATE_FUND = gql`
  query RDFQuery(
    $retirementAge: Int!
    $amountToInvest: Float!
    $birthDate: String!
    $isSummitMember: Boolean!
  ) {
    recommendedDateFund(
      birthDate: $birthDate
      retirementAge: $retirementAge
      amountToInvest: $amountToInvest
      dateFundType: RETIREMENT_DATE_FUND
      isSummitMember: $isSummitMember
    ) {
      name: shortName
      netAssets
      netAssetsAsOfDate
      price {
        asOfDate
        price
        priceChange
      }
      ticker
      trpCode
      cusip
      retirement
      targetYear
      iClass
      recordKeepingCode
      grossExpenseRatio
    }
  }
`;

export const getRDFRecommendation = memoize(
  async ({ birthDate, amount, isSummitMember = false }) => {
    const client = createClient();

    const {
      data: { recommendedDateFund }
    } = await client.query({
      query: RECOMMENDED_DATE_FUND,
      variables: {
        birthDate,
        retirementAge: RETIREMENT_AGE,
        amountToInvest: amount,
        isSummitMember
      }
    });
    return recommendedDateFund;
  },
  args =>
    Object.keys(args)
      .map(key => args[key])
      .join('.')
);
